import React, { useEffect } from "react"
import "./Contacto.css"
import "./Contacto2.css"

const Contacto = (props) => {
  const [isVisible, setIsVisible] = React.useState(props.isVisible)

  useEffect(() => {
    setIsVisible(props.isVisible)
  }, [props.isVisible])

  const handleClose = () => {
    props.onClose()
    setIsVisible(false)
  }

  const enviarFormulario = async (e) => {
    e.preventDefault()

    const nombre = e.target[0].value
    const correo = e.target[1].value
    const asunto = e.target[2].value
    const mensaje = e.target[3].value

    const data = new FormData()
    data.append("nombre", nombre)
    data.append("correo", correo)
    data.append("asunto", asunto)
    data.append("mensaje", mensaje)

    const response = await fetch("https://oxanaohb.com/enviarCorreo.php", {
      method: "POST",
      body: data,
    })

    const result = await response.json()

    if (result.success) {
      alert("Exitoso")
    } else {
      alert("Error")
    }
  }

  return (
    <div
      className={`contacto-container ${
        isVisible ? "contacto-visible" : "contacto-hidden"
      }`}
    >
      <div
        className="contact-container"
        style={{
          color: "#25326a",
        }}
      >
        <h2>¡Contáctanos!</h2>
        <hr
          style={{
            height: "2px",
            borderWidth: "0",
            color: "gray",
            backgroundColor: "#cdd8e5",
            marginTop: "10px",
            marginBottom: "20px",
          }}
        />
        <h3 className="contact-title">Datos de contacto comercial:</h3>

        <div className="contact-info">
          <p>
            <strong className="info-label">Teléfono:</strong>{" "}
            <span>621300544</span>
          </p>
          <p>
            <strong className="info-label">Correo:</strong>{" "}
            <span>oxana@oxanaohb.com</span>
          </p>
        </div>

        <h3 className="emergency-title">Contacto de emergencias:</h3>

        <div className="emergency-info">
          <p>
            <strong className="info-label">Teléfono:</strong>{" "}
            <span>+34 665838941</span>
          </p>
          <p>
            <strong className="info-label">Teléfono:</strong>{" "}
            <span>+34 656342804</span>
          </p>
          <p>
            <strong className="info-label">
              Perry For Emergency 24 hour service - please call:
            </strong>{" "}
            <span>800-741-4376</span>
          </p>
        </div>
        <hr
          style={{
            height: "2px",
            borderWidth: "0",
            color: "gray",
            backgroundColor: "#cdd8e5",
            marginTop: "10px",
            marginBottom: "20px",
          }}
        />
        <h2 className="form-title">Formulario de contacto:</h2>
        <div>
          <form className="contact-form" onSubmit={enviarFormulario}>
            <input
              className="input-field"
              type="text"
              placeholder="Nombre"
              required
            />
            <input
              className="input-field"
              type="email"
              placeholder="Correo"
              required
            />
            <input
              className="input-field"
              type="text"
              placeholder="Asunto"
              required
            />
            <textarea
              className="input-textarea"
              placeholder="Mensaje"
              required
            ></textarea>

            <div className="privacy-policy-check">
              <input type="checkbox" required />
              <label>He leido y acepto las políticas de privacidad</label>
            </div>

            <button className="submit-button" type="submit">
              Enviar
            </button>
          </form>
          <div className="espacio"></div>
        </div>
      </div>
    </div>
  )
}

export default Contacto
